export default __webpack_public_path__ + "static/initiative2-42237ca204504a2ed95563af71e7affb.webp";